import { tickerItems } from '@/mocks/homeData';

export default function TickerBar() {
  const loopItems = [...tickerItems, ...tickerItems];

  return (
    <div className="w-full border-b border-background-200 bg-background-100">
      <div className="mx-auto flex w-full max-w-[1360px] items-center gap-3 px-4 md:px-6">
        <span className="flex shrink-0 items-center gap-1.5 py-2.5 text-xs font-bold text-primary-600">
          <span className="pulse-dot flex h-2 w-2 rounded-full bg-primary-500" />
          实时刷新
        </span>
        <div className="relative flex-1 overflow-hidden">
          <div className="marquee-track flex w-max items-center gap-8 py-2.5">
            {loopItems.map((item, index) => (
              <span
                key={`${item}-${index}`}
                className="whitespace-nowrap text-xs text-foreground-600"
              >
                {item}
              </span>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}